module.exports = __webpack_public_path__ + "logo-orkla-tagline-fi-white-5d6032913d36e1b26d8d855798d7ae22.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-fi-white.svg
// module id = 65
// module chunks = 0